export enum ImportProductsIdentification {
    Symbol = 'Symbol'
}

export enum ImportClientsIdentification {
    Name = 'Name',
    Tin = 'Tin'
}
